<div class="frame-in">
    <div class="songs" [class.hidden]="loading()">
        <button type="button" class="leave-button" (click)="previousState()"></button>

        <button type="button" class="slider-back" (click)="previous()"></button>
        <button type="button" class="slider-next" (click)="next()"></button>

        <div>
            @for (tab of tabs(); track $index; let i = $index) {

            @if (activeWindow() === i + 1) {
            <div class="blocks-list">

                @for (item of tab; track $index; let index = $index) {
                <div class="item" [class.lock]="item.lock" [routerLink]="item.url">
                    <div class="number">{{ (i * 5) + index + 1 }}</div>
                    <div class="description-box">
                        “{{ item.songTitle }}” song - {{ item.countryTitle }}
                    </div>
                    <div class="letter-box n1-{{ (i * 5) + index + 1 }}"></div>
                    <div class="clearfix"></div>
                    <div class="border-box"></div>
                </div>
                }

            </div>
            }
            }
        </div>
        <img class="frame-bg" src="assets/images/songs/bg.jpg">
    </div>
</div>
